import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es.array.reduce.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { createCancelablePromise, Delayer } from '../../../base/common/async.js';
import { onUnexpectedError } from '../../../base/common/errors.js';
import { Emitter } from '../../../base/common/event.js';
import { Disposable, MutableDisposable } from '../../../base/common/lifecycle.js';
import { CharacterSet } from '../../common/core/characterClassifier.js';
import * as modes from '../../common/modes.js';
import { provideSignatureHelp } from './provideSignatureHelp.js';
var ParameterHintState;

(function (ParameterHintState) {
  ParameterHintState.Default = {
    type: 0
    /* Default */

  };

  var Pending = function Pending(request) {
    _classCallCheck(this, Pending);

    this.request = request;
    this.type = 2
    /* Pending */
    ;
  };

  ParameterHintState.Pending = Pending;

  var Active = function Active(hints) {
    _classCallCheck(this, Active);

    this.hints = hints;
    this.type = 1
    /* Active */
    ;
  };

  ParameterHintState.Active = Active;
})(ParameterHintState || (ParameterHintState = {}));

export var ParameterHintsModel = /*#__PURE__*/function (_Disposable) {
  _inherits(ParameterHintsModel, _Disposable);

  var _super = _createSuper(ParameterHintsModel);

  function ParameterHintsModel(editor) {
    var _this;

    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ParameterHintsModel.DEFAULT_DELAY;

    _classCallCheck(this, ParameterHintsModel);

    _this = _super.call(this);
    _this._onChangedHints = _this._register(new Emitter());
    _this.onChangedHints = _this._onChangedHints.event;
    _this.triggerOnType = false;
    _this._state = ParameterHintState.Default;
    _this._pendingTriggers = [];
    _this._lastSignatureHelpResult = _this._register(new MutableDisposable());
    _this.triggerChars = new CharacterSet();
    _this.retriggerChars = new CharacterSet();
    _this.triggerId = 0;
    _this.editor = editor;
    _this.throttledDelayer = new Delayer(delay);

    _this._register(_this.editor.onDidChangeConfiguration(function () {
      return _this.onEditorConfigurationChange();
    }));

    _this._register(_this.editor.onDidChangeModel(function (e) {
      return _this.onModelChanged();
    }));

    _this._register(_this.editor.onDidChangeModelLanguage(function (_) {
      return _this.onModelChanged();
    }));

    _this._register(_this.editor.onDidChangeCursorSelection(function (e) {
      return _this.onCursorChange(e);
    }));

    _this._register(_this.editor.onDidChangeModelContent(function (e) {
      return _this.onModelContentChange();
    }));

    _this._register(modes.SignatureHelpProviderRegistry.onDidChange(_this.onModelChanged, _assertThisInitialized(_this)));

    _this._register(_this.editor.onDidType(function (text) {
      return _this.onDidType(text);
    }));

    _this.onEditorConfigurationChange();

    _this.onModelChanged();

    return _this;
  }

  _createClass(ParameterHintsModel, [{
    key: "state",
    get: function get() {
      return this._state;
    },
    set: function set(value) {
      if (this._state.type === 2
      /* Pending */
      ) {
        this._state.request.cancel();
      }

      this._state = value;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.state = ParameterHintState.Default;
      this.throttledDelayer.cancel();

      if (!silent) {
        this._onChangedHints.fire(undefined);
      }
    }
  }, {
    key: "trigger",
    value: function trigger(context, delay) {
      var _this2 = this;

      var model = this.editor.getModel();

      if (!model || !modes.SignatureHelpProviderRegistry.has(model)) {
        return;
      }

      var triggerId = ++this.triggerId;

      this._pendingTriggers.push(context);

      this.throttledDelayer.trigger(function () {
        return _this2.doTrigger(triggerId);
      }, delay).catch(onUnexpectedError);
    }
  }, {
    key: "next",
    value: function next() {
      if (this.state.type !== 1
      /* Active */
      ) {
        return;
      }

      var length = this.state.hints.signatures.length;
      var activeSignature = this.state.hints.activeSignature;
      var last = activeSignature % length === length - 1;
      var cycle = this.editor.getOption(67
      /* parameterHints */
      ).cycle; // If there is only one signature, or we're on last signature of list

      if ((length < 2 || last) && !cycle) {
        this.cancel();
        return;
      }

      this.updateActiveSignature(last && cycle ? 0 : activeSignature + 1);
    }
  }, {
    key: "previous",
    value: function previous() {
      if (this.state.type !== 1
      /* Active */
      ) {
        return;
      }

      var length = this.state.hints.signatures.length;
      var activeSignature = this.state.hints.activeSignature;
      var first = activeSignature === 0;
      var cycle = this.editor.getOption(67
      /* parameterHints */
      ).cycle; // If there is only one signature, or we're on first signature of list

      if ((length < 2 || first) && !cycle) {
        this.cancel();
        return;
      }

      this.updateActiveSignature(first && cycle ? length - 1 : activeSignature - 1);
    }
  }, {
    key: "updateActiveSignature",
    value: function updateActiveSignature(activeSignature) {
      if (this.state.type !== 1
      /* Active */
      ) {
        return;
      }

      this.state = new ParameterHintState.Active(Object.assign(Object.assign({}, this.state.hints), {
        activeSignature: activeSignature
      }));

      this._onChangedHints.fire(this.state.hints);
    }
  }, {
    key: "doTrigger",
    value: function doTrigger(triggerId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var isRetrigger, activeSignatureHelp, context, triggerContext, model, position, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isRetrigger = this.state.type === 1
                /* Active */
                || this.state.type === 2;
                activeSignatureHelp = this.state.type === 1
                /* Active */
                ? this.state.hints : undefined;
                this.cancel(true);

                if (!(this._pendingTriggers.length === 0)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", false);

              case 5:
                context = this._pendingTriggers.reduce(mergeTriggerContexts);
                this._pendingTriggers = [];
                triggerContext = {
                  triggerKind: context.triggerKind,
                  triggerCharacter: context.triggerCharacter,
                  isRetrigger: isRetrigger,
                  activeSignatureHelp: activeSignatureHelp
                };

                if (this.editor.hasModel()) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", false);

              case 10:
                model = this.editor.getModel();
                position = this.editor.getPosition();
                this.state = new ParameterHintState.Pending(createCancelablePromise(function (token) {
                  return provideSignatureHelp(model, position, triggerContext, token);
                }));
                _context.prev = 13;
                _context.next = 16;
                return this.state.request;

              case 16:
                result = _context.sent;

                if (!(triggerId !== this.triggerId)) {
                  _context.next = 20;
                  break;
                }

                result === null || result === void 0 ? void 0 : result.dispose();
                return _context.abrupt("return", false);

              case 20:
                if (!(!result || !result.value.signatures || result.value.signatures.length === 0)) {
                  _context.next = 27;
                  break;
                }

                result === null || result === void 0 ? void 0 : result.dispose();

                this._lastSignatureHelpResult.clear();

                this.cancel();
                return _context.abrupt("return", false);

              case 27:
                this.state = new ParameterHintState.Active(result.value);
                this._lastSignatureHelpResult.value = result;

                this._onChangedHints.fire(this.state.hints);

                return _context.abrupt("return", true);

              case 31:
                _context.next = 38;
                break;

              case 33:
                _context.prev = 33;
                _context.t0 = _context["catch"](13);

                if (triggerId === this.triggerId) {
                  this.state = ParameterHintState.Default;
                }

                onUnexpectedError(_context.t0);
                return _context.abrupt("return", false);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[13, 33]]);
      }));
    }
  }, {
    key: "isTriggered",
    get: function get() {
      return this.state.type === 1
      /* Active */
      || this.state.type === 2
      /* Pending */
      || this.throttledDelayer.isTriggered();
    }
  }, {
    key: "onModelChanged",
    value: function onModelChanged() {
      this.cancel(); // Update trigger characters

      this.triggerChars = new CharacterSet();
      this.retriggerChars = new CharacterSet();
      var model = this.editor.getModel();

      if (!model) {
        return;
      }

      var _iterator = _createForOfIteratorHelper(modes.SignatureHelpProviderRegistry.ordered(model)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var support = _step.value;

          var _iterator2 = _createForOfIteratorHelper(support.signatureHelpTriggerCharacters || []),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var ch = _step2.value;
              this.triggerChars.add(ch.charCodeAt(0)); // All trigger characters are also considered retrigger characters

              this.retriggerChars.add(ch.charCodeAt(0));
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var _iterator3 = _createForOfIteratorHelper(support.signatureHelpRetriggerCharacters || []),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _ch = _step3.value;
              this.retriggerChars.add(_ch.charCodeAt(0));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "onDidType",
    value: function onDidType(text) {
      if (!this.triggerOnType) {
        return;
      }

      var lastCharIndex = text.length - 1;
      var triggerCharCode = text.charCodeAt(lastCharIndex);

      if (this.triggerChars.has(triggerCharCode) || this.isTriggered && this.retriggerChars.has(triggerCharCode)) {
        this.trigger({
          triggerKind: modes.SignatureHelpTriggerKind.TriggerCharacter,
          triggerCharacter: text.charAt(lastCharIndex)
        });
      }
    }
  }, {
    key: "onCursorChange",
    value: function onCursorChange(e) {
      if (e.source === 'mouse') {
        this.cancel();
      } else if (this.isTriggered) {
        this.trigger({
          triggerKind: modes.SignatureHelpTriggerKind.ContentChange
        });
      }
    }
  }, {
    key: "onModelContentChange",
    value: function onModelContentChange() {
      if (this.isTriggered) {
        this.trigger({
          triggerKind: modes.SignatureHelpTriggerKind.ContentChange
        });
      }
    }
  }, {
    key: "onEditorConfigurationChange",
    value: function onEditorConfigurationChange() {
      this.triggerOnType = this.editor.getOption(67
      /* parameterHints */
      ).enabled;

      if (!this.triggerOnType) {
        this.cancel();
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.cancel(true);

      _get(_getPrototypeOf(ParameterHintsModel.prototype), "dispose", this).call(this);
    }
  }]);

  return ParameterHintsModel;
}(Disposable);
ParameterHintsModel.DEFAULT_DELAY = 120; // ms

function mergeTriggerContexts(previous, current) {
  switch (current.triggerKind) {
    case modes.SignatureHelpTriggerKind.Invoke:
      // Invoke overrides previous triggers.
      return current;

    case modes.SignatureHelpTriggerKind.ContentChange:
      // Ignore content changes triggers
      return previous;

    case modes.SignatureHelpTriggerKind.TriggerCharacter:
    default:
      return current;
  }
}